import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Overlay from './../../reusable/Overlays/Overlay';
import SanctionsWarningsTable from './SanctionsWarningsTable';

// DEPRECATED
class SanctionsWatchlistOverlay extends Component {
    static propTypes = {
        entityName: PropTypes.string,
        companyId: PropTypes.string,
        closeOverlay: PropTypes.func,
        items: PropTypes.arrayOf(PropTypes.any),
        loadItems: PropTypes.func,
        resetSanctions: PropTypes.func,
        isLoading: PropTypes.bool,
        totalCount: PropTypes.number,
        hasError: PropTypes.bool
    }

    componentWillMount() {
        this.props.resetSanctions();
        this.props.loadItems(this.props.entityName, this.props.companyId)
    }

    render() {
        return (
            <Overlay
                closeOverlay={this.props.closeOverlay}
                className={"sanctions-watchlist__overlay"}
                title={this.props.entityName +": "  + this.props.intl.formatMessage({id: 'Dashboard_Charts_UIText_dashboard.sanctionsPod.overlayHeader'})}>
                <SanctionsWarningsTable { ...this.props } />
            </Overlay>
        )
    }
}

export default injectIntl(SanctionsWatchlistOverlay);


// WEBPACK FOOTER //
// ./src/scripts/pages/SanctionsWarnings/SanctionsWarningsOverlayTable.jsx